import React, { useState } from 'react';
import { Box, Grid, TextField, MenuItem, Button } from '@mui/material';
import { MdClear } from 'react-icons/md';
import MuiAUtocomplete from 'components/MuiAutocomplete';
import useAppQuery from 'hooks/useAppQuery';
import { config } from 'variables/config';

const ENTITY_TYPES = [
  { value: '', label: 'Toutes entités' },
  { value: 'ENTERPRISE', label: 'Entreprise' },
  { value: 'CONTRACT', label: 'Contrat' },
  { value: 'EMPLOYER', label: 'Employeur' },
  { value: 'REQUEST', label: 'Demande' },
  { value: 'REPORT', label: 'Rapport' },
  { value: 'TASK', label: 'Tâche' },
  { value: 'USER', label: 'Utilisateur' },
  { value: 'AUTH', label: 'Authentification' },
];

const ACTION_TYPES = [
  { value: '', label: 'Toutes actions' },
  { value: 'LOGIN', label: 'Connexion' },
  { value: 'CREATE', label: 'Création' },
  { value: 'UPDATE', label: 'Modification' },
  { value: 'APPROVE', label: 'Approbation' },
  { value: 'REJECT', label: 'Rejet' },
  { value: 'DELETE', label: 'Suppression' },
  { value: 'READ', label: 'Consultation' },
  { value: 'SUBMIT', label: 'Soumission' },
  { value: 'COMPLETE', label: 'Complétion' },
];

export default function ActivityFilters({ filters, onChange }) {
  const [selectedUser, setSelectedUser] = useState(null);

  const { data: usersData } = useAppQuery(`${config.app.api_url}/users`);

  const userOptions = (usersData?.data ?? usersData ?? []).map((u) => ({
    value: u.id,
    label: u.fullName ?? `${u.firstName ?? ''} ${u.lastName ?? ''}`.trim(),
  }));

  const handleChange = (field) => (e) => {
    onChange({ ...filters, [field]: e.target.value || null });
  };

  const handleReset = () => {
    setSelectedUser(null);
    onChange({ userId: null, entityType: null, actionType: null, start: null, end: null });
  };

  return (
    <Box sx={{ mb: 2, p: 2, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 1 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={6} md={2}>
          <MuiAUtocomplete
            label="Rechercher un utilisateur"
            value={selectedUser}
            options={userOptions}
            onChange={(_, item) => {
              setSelectedUser(item);
              onChange({ ...filters, userId: item?.value ?? null });
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <TextField
            select
            label="Type d'entité"
            size="small"
            fullWidth
            value={filters.entityType ?? ''}
            onChange={handleChange('entityType')}
          >
            {ENTITY_TYPES.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <TextField
            select
            label="Type d'action"
            size="small"
            fullWidth
            value={filters.actionType ?? ''}
            onChange={handleChange('actionType')}
          >
            {ACTION_TYPES.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <TextField
            label="Date début"
            type="date"
            size="small"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={filters.startDate ?? ''}
            onChange={(e) =>
              onChange({
                ...filters,
                start: e.target.value ? new Date(e.target.value).getTime() : null,
                startDate: e.target.value,
              })
            }
          />
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <TextField
            label="Date fin"
            type="date"
            size="small"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={filters.endDate ?? ''}
            onChange={(e) =>
              onChange({
                ...filters,
                end: e.target.value ? new Date(e.target.value).getTime() : null,
                endDate: e.target.value,
              })
            }
          />
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <Button
            variant="outlined"
            startIcon={<MdClear />}
            onClick={handleReset}
            fullWidth
            size="small"
          >
            Réinitialiser
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
